import axios from 'axios';

const getPaises = params => axios.get('/open/paises/page', { params });

export default {
  getPaises,
};
